module.exports = __webpack_public_path__ + "static/img/pic_pico05@2x.820f2cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_pico05@2x.png
// module id = S2kP
// module chunks = 0